import {EwSiteApp} from '../../app/ewsiteapp';

EwSiteApp.controller('VoteCtrl',['$scope', '$http', '$log', function($scope, $http, $log) {
	$scope.voteUrl = '';
	$scope.loading = false;
	
	$scope.voteData = {
		recaptchaResponse: null,
	};
	
	$scope.doVote = function(id, vote){
		$scope.loading = true;
		if (typeof grecaptcha !== 'undefined') {
			grecaptcha.ready(function() {
				grecaptcha.execute($('#g-recaptcha-response-hidden').data('sitekey'), {action:'submit'}).then(function(token) {
//					document.getElementById('g-recaptcha-response-hidden').value = token;
					$scope.voteData.recaptchaResponse = token;
					$scope.submitVote(id, vote); 
				});
			});
		}
	};
	
	$scope.submitVote = function(id, vote){
		if($scope.voteUrl !== ''){
			var vote_data = {
				question_id: id,
				vote: vote,
				xsrfCookieName: secure_xsrf_name,
				xsrfHeaderName: 'X-' + secure_xsrf_name
			};
			
			if(typeof jsFaq.recaptcha !== 'undefined'){
				vote_data[jsFaq.recaptcha.field] = $scope.voteData.recaptchaResponse;
			}

			$http({
				method: 'POST',
				url: $scope.voteUrl,
				data: vote_data
			}).then(function(response){
				$scope.loading = false;
				if(response.data.data.success) {
					if(vote=='no'){
						$('#faqSuccess'+id).hide();
						$('#faqIsuseful'+id).hide();
						$('#faqExplain'+id).show();
					}
					else {
						$('#faqSuccess'+id).show();
						$('#faqIsuseful'+id).hide();
						$('#faqExplain'+id).hide();
					}
				}
				else if(angular.isDefined(response.data.data.messages)){
					$scope.errors = response.data.data.messages;
				}
				if(angular.isDefined(response.data.data.debug)){
					$log.debug(response.data.data.debug);
				}
			});
		}
	};
}]).directive('voteList', function(){
	return {
		restrict: 'A',
		link: function (scope, element, attr) {
			scope.voteUrl = '';

			if(attr.voteUrl && attr.voteUrl !== ''){
				scope.voteUrl = unescape(attr.voteUrl);
			}
		}
	};
});
